import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Hemberger } from "../assets/icons/Hemberger.svg";
import { ReactComponent as UserIcon } from "../assets/icons/UserIcon.svg";
import Sidebar from "../sidenav/Sidenav";
import {
  Button,
  Table,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  FormControl,
  ListItemText,
  Checkbox,
  MenuItem,
  OutlinedInput,
  InputLabel,
  Select,
  Autocomplete,
  Typography,
  Grid,
} from "@mui/material";
import { ReactComponent as Dustbin } from "../assets/Dustbin.svg";
import { hasStoredTabAccess } from '../utils/access';

import { ArrowBackIosNewRounded } from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";
import isDesktop from "../isDesktop";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { tableCellClasses } from "@mui/material/TableCell";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import TextEditor from "../Components/TextEditor/TextEditor";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DialogTextField from "../Components/Dialog/DialogTextField";



const OffersMobile = () => {
      const [isSidebarOpen, setIsSidebarOpen] = useState(false);
      const navigate = useNavigate();
      const closeSidebar = () => {
        setIsSidebarOpen(false);
      };
    const [isOpen, setIsOpen] = useState({
        add: false,
        update: false,
      });
      const [isReplicateDialogOpen, setIsReplicateDialogOpen] = useState(false);
      const [postData, setPostData] = useState({
        id: "",
        name: "",
        specId: "",
        features: [],
        basicFeatures: [],
        basicCostMonthly: "",
        basicCostYearly: "",
        standardFeatures: [],
        standardCostMonthly: "",
        standardCostYearly: "",
        premiumFeatures: [],
        premiumCostMonthly: "",
        premiumCostYearly: "",
        discount: "",
      });
      const [specialization, setSpecialization] = useState([]);
      const [offers, setOffers] = useState([]);
      const [isDeleteOpen,setIsDeleteOpen]=useState(false)
      const [offerToDelete,setOfferToDelete]=useState(null)
      const [offerToReplicate,setOfferToReplicate]=useState(null)
      const isAuthorized = hasStoredTabAccess('Offers');


      function Row(props) {
        const { row } = props;
        const [open, setOpen] = React.useState(false);
    
        return (
          <React.Fragment>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
            <TableCell component="th" scope="row">
                <div>{row?.id}</div>
              </TableCell>
              <TableCell component="th" scope="row">
                <div>{row?.offer_name}</div>
              </TableCell>
              <TableCell style={{ textAlign: "end" }}>
                <IconButton
                  aria-label="expand row"
                  style={{ color: "black" }}
                  size="small"
                  onClick={() => setOpen(!open)}
                >
                  {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                "& td": { border: 0, height: open ? "auto" : 0 },
                borderBottom: "1px solid black",
              }}
            >
              <TableCell
                style={{ paddingBottom: 0, paddingTop: 0, borderTop: "none" }}
                colSpan={6}
              >
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <div
                    style={{
                      fontSize: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <div style={{ flex: "1" }}>Actions:</div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.4rem",
                      }}
                    >
                      <Button
                        onClick={() => {
                            handlReplicateDialogOpen(row?.id);
                        }}
                        className="actionMobileBtn"
                        style={{
                          backgroundColor: "#FCF6BC",
                          color: "black",
                        }}
                      >
                        Replicate
                      </Button>
                      <Button
                        onClick={() => {
                            onEditOpen(row?.id);
                        }}
                        className="actionMobileBtn"
                        style={{
                          backgroundColor: "#D1F4DE",
                          color: "black",
                        }}
                      >
                        Edit
                      </Button>
                      <Button
                        onClick={() => {
                             setIsDeleteOpen(true);setOfferToDelete(row?.id);
                        }}
                        className="actionMobileBtn"
                        style={{
                          backgroundColor: "#FFD6D2",
                          color: "black",
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
        );
      }
    
      const fetchSpecializations = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/specialization/all`
          );
    
          if (response.status === 200) {
            console.log(response.data.data);
            setSpecialization(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching specialization data", error);
        }
      };
    
      const fetchAllOffers = useCallback(async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/get/all`
          );
          setOffers(response?.data?.data);
        } catch (error) {
          console.error(error);
        }
      }, []);
    
      const AddOffer = async () => {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/post`,
            {
              ...postData,
            }
          );
          if (response.status === 200) {
            toast.success("Offer added successfully");
            fetchAllOffers();
            handleClose();
          }
        } catch (error) {
          console.error(error);
    
          toast.error("Error adding offer");
        }
      };
    
      const editOffer = async () => {
        try {
          const response = await axios.patch(
            `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/edit/${postData.id}`,
            {
              ...postData,
            }
          );
          if (response.status === 200) {
            toast.success("Offer edited successfully");
            fetchAllOffers();
            handleClose();
          }
        } catch (error) {
          console.error(error);
    
          toast.error("Error adding offer");
        }
      };
    
    
      const handleConfirmDelete=async()=>{
        try {
    
          const response = await axios.patch(
            `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/delete/${offerToDelete}`
          );
          if (response.status===200) {
            toast.success("Offer deleted Successfully")
            setIsDeleteOpen(false)
            setOfferToDelete(null)
            fetchAllOffers()
          }
        } catch (error) {
          console.error(error);
    
          toast.error(error.response.data.message);
        }
      }
    
      const onEditOpen = async (id) => {
        try {
    
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/get/${id}`
          );
          const data = response.data.data[0];
          const specName = specialization.find(
            (spec) => spec.specialization_id === data.spec_id
          );
          setPostData({
            id: id,
            name: data.offer_name,
            specId: data.spec_id,
            specName: specName,
            features: JSON.parse(data.features),
            basicFeatures: JSON.parse(data.basic_features),
            basicCostMonthly: data.basic_cost_monthly,
            basicCostYearly: data.basic_cost_yearly,
            standardFeatures: JSON.parse(data.standard_features),
            standardCostMonthly: data.standard_cost_monthly,
            standardCostYearly: data.standard_cost_yearly,
            premiumFeatures: JSON.parse(data.premium_features),
            premiumCostMonthly: data.premium_cost_monthly,
            premiumCostYearly: data.premium_cost_yearly,
            discount: data.discount,
          });
          await fetchSpecializations();
          setIsOpen({
            add: false,
            update: true,
          });
        } catch (error) {
          console.error(error);
    
          toast.error(error.response.data.message);
        }
      };
    
      const handleClose = () => {
        setIsOpen({ open: false, update: false });
        setPostData({
          id: "",
          name: "",
          specId: "",
          features: [],
          basicFeatures: [],
          basicCostMonthly: "",
          basicCostYearly: "",
          standardFeatures: [],
          standardCostMonthly: "",
          standardCostYearly: "",
          premiumFeatures: [],
          premiumCostMonthly: "",
          premiumCostYearly: "",
          discount: "",
        });
      };
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value);
        setPostData((prev) => ({ ...postData, [name]: value }));
      };
    
      const handleSelectChange = (e) => {
        const { name, value } = e.target;
        console.log(value);
    
        setPostData((prev) => ({
          ...postData,
          [name]: typeof value === "string" ? value.split(",") : value,
        }));
      };
    
      useEffect(() => {
        fetchAllOffers();
      }, [fetchAllOffers]);
    
      const handleBack = () => {
        navigate("/");
      };
    
      const onAddPress = () => {
        fetchSpecializations();
        setIsOpen((prev) => ({
          ...prev,
          add: true,
        }));
      };
    
      if (!isAuthorized) {
        return (
          <div className="container-fluid mt-5">
            <h2 style={{ marginTop: "2rem" }}>
              You are unauthorized to access this page
            </h2>
          </div>
        );
      }
    
      const handleFeatureChange = (e, index) => {
        const { value } = e.target;
        const featureArray = [...postData.features];
        featureArray[index] = value;
        setPostData((prev) => ({
          ...prev,
          features: featureArray,
        }));
      };
    
      const addFeature = () => {
        setPostData((prev) => ({
          ...prev,
          features: [...prev.features, ""],
        }));
      };
    
      const deleteFeature = (index) => {
        const featuresArr = [...postData.features];
        const basicFeatures = [...postData.basicFeatures].filter(
          (val) => val !== index
        );
        const standardFeatures = [...postData.standardFeatures].filter(
          (val) => val !== index
        );
        const premiumFeatures = [...postData.premiumFeatures].filter(
          (val) => val !== index
        );
        featuresArr.splice(index, 1);
        setPostData((prev) => ({
          ...prev,
          features: featuresArr,
          basicFeatures: basicFeatures,
          standardFeatures: standardFeatures,
          premiumFeatures: premiumFeatures,
        }));
      };
    
      const handleReplicateSubmit=async()=>{
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/replicate`,
            {
              id:offerToReplicate,
              newName:postData.name,
              newSpecId:postData.specId
            }
          );
          if (response.status === 200) {
            toast.success("Offer Replicated successfully");
            fetchAllOffers();
            handleReplicateDialogClose();
          }
        } catch (error) {
          console.error(error);
    
          toast.error(error.response.data.message);
        }
      }
    
      const handlReplicateDialogOpen=async(id)=>{
        await fetchSpecializations();
        setOfferToReplicate(id)
        setIsReplicateDialogOpen(true);
      }
    
      const handleReplicateDialogClose = () => {
        setIsReplicateDialogOpen(false);
        setOfferToReplicate(null)
        setPostData({
          id: "",
          name: "",
          specId: "",
          features: [],
          basicFeatures: [],
          basicCostMonthly: "",
          basicCostYearly: "",
          standardFeatures: [],
          standardCostMonthly: "",
          standardCostYearly: "",
          premiumFeatures: [],
          premiumCostMonthly: "",
          premiumCostYearly: "",
          discount: "",
        })
    
      };

  return (
    <>
    <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0.5rem 0.75rem 1.25rem 0.75rem",
        }}
      >
        <div
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "36px",
            height: "36px",
            borderRadius: "18px",
            background: "#EAF1F7",
          }}
        >
          <Hemberger />
        </div>
        <Link to={"/profile"}>
          <UserIcon style={{ cursor: "pointer" }} />
        </Link>
      </div>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0rem 0.75rem 1.5rem 0.75rem",
        }}
      >
        <div className="container-fluid">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom:"2.25rem"
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "1vw",
                alignItems: "center",
                
              }}
            >
              <ArrowBackIosNewRounded
                onClick={() => {
                  handleBack();
                }}
                style={{ cursor: "pointer" }}
              />
              <h4 style={{ marginRight: "1rem", marginBottom: "0px" }}>
                Offers
              </h4>
            </div>
            <Button
              onClick={onAddPress}
              className="button-two"
              style={{
                width: "6rem",
                height: "1.75rem",
                background: "#37446F",
              }}
            >
              Add
            </Button>
          </div>
          <Table
            aria-label="collapsible table"
            sx={{
              [`& .${tableCellClasses.root}`]: {
                borderBottom: "none",
              },
            }}
          >
            <TableHead
              style={{
                height: "44px",
                borderRadius: "4px !important",
                background: "rgba(234, 241, 247, 1)",
                boxShadow: "2px 2px 4px 0px rgba(174, 174, 192, 0.5)",
              }}
            >
              <TableRow>
                <TableCell>S. No.</TableCell>
                <TableCell>Name</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {offers?.map((brand, ind) => (
                <Row key={ind} row={brand} />
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
      <Dialog
        open={isOpen.add || isOpen.update}
        PaperProps={{
          style: {
            width: "fit-content",
            maxWidth: "80vw",
            padding: "1.5rem",
            borderRadius: "0.513vw",
            overflowX: "hidden",
            boxShadow:
              "4px 4px 8px 0px #AEAEC099, box-shadow: -4px -4px 8px 0px #FFFFFF80",
          },
        }}
        onClose={handleClose}
      >
        <DialogTitle style={{ fontWeight: "600", paddingBottom: "0" }}>
          {isOpen.update ? "Edit" : "Add"} Plan
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <DialogTextField
                name="name"
                label="New Plan Name"
                fullWidth
                required
                value={postData.name}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                id="specId"
                options={specialization}
                fullWidth
                getOptionLabel={(option) => option?.specialization_name}
                value={postData.specName}
                onChange={(e, value) => {
                  setPostData((prev) => {
                    return {
                      ...prev,
                      specId: value?.specialization_id,
                      specName: value?.specialization_name,
                    };
                  });
                }}
                renderInput={(params) => (
                  <DialogTextField
                    {...params}
                    variant="outlined"
                    required
                    fullWidth
                    label="Specialization Name"
                    // placeholder="Specialization Name"

                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="basicFeatures">Basic Plan Features</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="basicFeatures"
                  fullWidth
                  multiple
                  name="basicFeatures"
                  value={postData.basicFeatures}
                  onChange={handleSelectChange}
                  input={<OutlinedInput label="Basic Plan Features" />}
                  renderValue={(selected) => selected.join(", ")}
                  // MenuProps={MenuProps}
                >
                  {postData.features.map((name, index) => (
                    <MenuItem key={name} value={index}>
                      <Checkbox
                        checked={postData.basicFeatures.includes(index)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <DialogTextField
                label="Monthly Price"
                required
                name="basicCostMonthly"
                value={postData.basicCostMonthly}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <DialogTextField
                label="Yearly Price"
                required
                name="basicCostYearly"
                value={postData.basicCostYearly}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="basicFeatures">
                  Standard Plan Features
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  fullWidth
                  multiple
                  value={postData.standardFeatures}
                  name="standardFeatures"
                  onChange={handleSelectChange}
                  input={<OutlinedInput label="Standard Plan Features" />}
                  renderValue={(selected) => selected.join(", ")}
                  // MenuProps={MenuProps}
                >
                  {postData.features.map((name, index) => (
                    <MenuItem key={name} value={index}>
                      <Checkbox
                        checked={postData.standardFeatures.includes(index)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <DialogTextField
                name="standardCostMonthly"
                label="Monthly Price"
                value={postData.standardCostMonthly}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <DialogTextField
                label="Yearly Price"
                name="standardCostYearly"
                value={postData.standardCostYearly}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="basicFeatures">
                  Premium Plan Features
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  fullWidth
                  multiple
                  name="premiumFeatures"
                  value={postData.premiumFeatures}
                  onChange={handleSelectChange}
                  input={<OutlinedInput label="Premium Plan Features" />}
                  renderValue={(selected) => selected.join(", ")}
                  // MenuProps={MenuProps}
                >
                  {postData.features.map((name, index) => (
                    <MenuItem key={name} value={index}>
                      <Checkbox
                        checked={postData.premiumFeatures.includes(index)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <DialogTextField
                label="Monthly Price"
                fullWidth
                name="premiumCostMonthly"
                value={postData.premiumCostMonthly}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
              <DialogTextField
                label="Yearly Price"
                name="premiumCostYearly"
                value={postData.premiumCostYearly}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <DialogTextField
                fullWidth
                name="discount"
                value={postData.discount}
                onChange={handleInputChange}
                label="Discount"
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} marginTop={3}>
            <Grid item xs={5}>
              <Typography
                style={{
                  fontWeight: "600",
                  paddingBottom: "0",
                  fontSize: "1.25rem",
                  lineHeight: 1.6,
                }}
              >
                Features
              </Typography>
            </Grid>
            <Grid
              item
              container
              xs={7}
              direction={"row"}
              justifyContent={"end"}
            >
              <Button
                ariant="contained"
            className="filled-button"
                fullWidth   
                onClick={addFeature}
              >
                Add Features
              </Button>
            </Grid>
            {postData.features.map((feature, index) => (
              <Grid
                item
                container
                xs={12}
                sx={{
                  gap: "1.026vw",
                }}
                key={index}
              >
                <Grid
                item
                xs={9}
                >
                <DialogTextField
                  label="Feature"
                  value={feature}
                  fullWidth
                  onChange={(e) => {
                    handleFeatureChange(e, index);
                  }}
                />
                </Grid>
                <Grid
                item
                xs={2}
                >
                <IconButton
                  style={{
                    borderRadius: "0px",
                    padding: "13px",
                    boxShadow:
                      "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                  }}
                  xs
                  onClick={() => {
                    deleteFeature(index);
                  }}
                >
                  <Dustbin />
                </IconButton>
                </Grid>
                
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            className="outlined-button"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              isOpen.add ? AddOffer() : editOffer();
            }}
            variant="contained"
            className="filled-button"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isReplicateDialogOpen}
        onClose={handleReplicateDialogClose}
        PaperProps={{
          style: {
            // width: "35.128vw",
            borderRadius: "0.513vw",
            boxShadow:
              "4px 4px 8px 0px #AEAEC099, box-shadow: -4px -4px 8px 0px #FFFFFF80",
          },
        }}
      >
        <DialogTitle>Replicate Subscription Plan</DialogTitle>
        <DialogContent>
          <DialogTextField
            name="name"
            label="New Plan Name"
            fullWidth
            required
            value={postData.name}
            onChange={handleInputChange}
            style={{
              width: "32.051vw",
              marginBottom:"1vw",
              marginTop:"0.5vw"
            }}
          />
          <Autocomplete
            id="specId"
            options={specialization}
            getOptionLabel={(option) => option?.specialization_name}
            value={postData.specName}
            fullWidth
            onChange={(e, value) => {
              setPostData((prev) => {
                return {
                  ...prev,
                  specId: value?.specialization_id,
                  specName: value?.specialization_name,
                };
              });
            }}
            renderInput={(params) => (
              <DialogTextField
                {...params}
                variant="outlined"
                required
                fullWidth
                label="Specialization Name"
                // placeholder="Specialization Name"
                style={{
                  marginBottom:"1vw"
                }}
              />
            )}
          />

          <DialogActions>
            <Button
              onClick={handleReplicateDialogClose}
              className="outlined-button"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleReplicateSubmit}
              className="filled-button"
              variant="contained"
            >
              Replicate
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog
          open={isDeleteOpen}
          onClose={(prev) => !prev}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ textAlign: "center" }}
        >
          <ErrorOutlineIcon
            style={{ color: "red", fontSize: "32px", margin: "12px auto" }}
          />
          <DialogTitle
            id="alert-dialog-title"
            style={{ fontSize: "18px", fontWeight: "500", lineHeight: "0" }}
          >
            {"Are you Sure?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              style={{ fontSize: "12px" }}
            >
              You won't be able to revert this!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {setIsDeleteOpen(false);
                setOfferToDelete(null)}
              }
              style={{
                textTransform: "none",
                width: "120px",
                height: "36px",
                border: "2.03px solid #37446F",
                borderRadius: "5.85px",
                background: "none",
                color: "black",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmDelete}
              style={{
                textTransform: "none",
                width: "120px",
                height: "36px",
                borderRadius: "5.85px",
                background: "#37446F",
                color: "white",
              }}
              autoFocus
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
    </>
  )
}

export default OffersMobile